<template>
  <div>
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"></SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total"
      :allBtnWidth="'200px'" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "FinanceStabilizationFund",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'poolrecord',
      formInline: { iswork: 1 },
      formCtrl: [
        {
          keyName: "name",
          placeholder: "请填写司机姓名",
          type: "text",
        },
      ],
      cols: [
        { keyName: "name", label: "司机姓名" },
        { keyName: "fundmoney", label: "累计金额"},
        { keyName: "getmoney", label: "可提取金额" },
        { keyName: "starttime", label: "开始时间" },
        { keyName: "endtime", label: "提取时间" },
      ],
      btns: [
        {
          img: require('@/assets/img/icon_operate_10.png'),
          title: '提成记录',
          cb: ({ id }) => {
            this.$router.push(
              `/finance/commissionRecord?driverid=${id}`
            );
          },
        },
        {
          img: require('@/assets/img/icon_operate_08.png'),
          title: '提取记录',
          cb: ({ id }) => {
            this.$router.push(
              `/finance/extractRecord?driverid=${id}`
            );
          },
        },
        {
          ...this.editBtn,
          title: '提取',
          cb: ({ id, getmoney }) => {
            if (!getmoney) {
              this.$message({
                type: 'warning',
                message: '金额为0不能提取!',
              });
              return
            }
            this.$confirm(`您是确定要提取金额为${getmoney}元？`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              console.log(id)
              this.extractReq({ id, getmoney });
            }).catch(() => { });
          },
        },
      ],
      baseParams: ['iswork'],
    };
  },
  methods: {
    extractReq({ id, getmoney }) {
      this.loading = true
      let url = `${this.baseUrl}/getmoneypool`;
      const params = {
        userid: this.user.id,
        driverid: id,
        getmoney,
      }
      this.post(url, params, ({ msg }) => {
        this.loading = false
        if (msg == 'success') {
          this.$message({
            type: 'success',
            message: '提取成功!',
          });
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: '提取失败，请稍后再试！'
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提取失败，请稍后重试！'
        });
      })
    },
  },
  watch: {
    $route() {
      // console.log(from.path, to.path)
      // console.log(this.$route.params)
      const { iswork } = this.$route.params
      this.formInline.iswork = iswork
      this.getList()
    },
  },
  mounted() {
    const { iswork } = this.$route.params
    this.formInline.iswork = iswork
    this.getList()
  },
};
</script>
